import {
  ComponentsProps,
  ComponentsOverrides,
  Theme,
  ComponentsVariants,
  ButtonPropsSizeOverrides,
} from "@mui/material";
import { SizeRange } from "../../..";

export const MuiButtonOverride: {
  defaultProps?: ComponentsProps["MuiButton"];
  styleOverrides?: ComponentsOverrides<Theme>["MuiButton"];
  variants?: ComponentsVariants["MuiButton"];
} = {
  variants: [
    {
      props: { size: "sm" },
      style: {
        padding: "0.3rem 0.5rem",
      },
    },
    {
      props: { size: "md" },
      style: {
        padding: "0.625rem 0.875rem",
      },
    },
    {
      props: { size: "lg" },
      style: {
        padding: "0.625rem 1rem",
      },
    },
    {
      props: { size: "xl" },
      style: {
        padding: "0.75rem 1.125rem",
      },
    },
    {
      props: { size: "2xl" },
      style: {
        padding: "1rem 1.375rem",
      },
    },
  ],
  styleOverrides: {
    root: {
      borderRadius: 8,
      padding: 16,
      textTransform: "capitalize",
    },
    contained: {
      boxShadow: "none",

      "&:hover": {
        boxShadow: "none",
      },
    },
    outlined: {
      fontWeight: 500,
      borderRadius: 8,
      padding: 15,
    },
  },
};

declare module "@mui/material/Button" {
  export interface ButtonPropsSizeOverrides {
    xs?: true;
    sm?: true;
    md?: true;
    lg?: true;
    xl?: true;
    "2xl"?: true;
  }
}
